
export class InteractionStateMachineData {

  private readonly _id: string
  private readonly _type: string

  constructor(id: string,
              type: string) {
    this._id = id
    this._type = type
  }

  get id() { return this._id }
  get type() { return this._type }
}

export type InteractionStateMachinePhase = 'initial-state' | 'waiting-for-remote-state' | 'loaded-state'
